import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../components/index'),
    meta: {
      title: 'index',
      requiresAuth: true
    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../components/detail'),
    meta: {
      title: 'detail',
      requiresAuth: true,
    }
  },
  {
    path: '/picture',
    name: 'picture',
    component: () => import('../components/picture'),
    meta: {
      title: 'picture',
      requiresAuth: true,
    }
  },
  {
    path: '/picture_vertical',
    name: 'picture_vertical',
    component: () => import('../components/picture_vertical'),
    meta: {
      title: 'picture_vertical',
      requiresAuth: true,
    }
  },
  {
    path: '/picture_empty',
    name: 'picture_empty',
    component: () => import('../components/picture_empty'),
    meta: {
      title: 'picture_empty',
      requiresAuth: true,
    }
  },
  {
    path: '/picture_video',
    name: 'picture_video',
    component: () => import('../components/picture_video'),
    meta: {
      title: 'picture_video',
      requiresAuth: true,
    }
  },
  {
    path: '/book_math',
    name: 'book_math',
    component: () => import('../components/book_math'),
    meta: {
      title: 'book_math',
      requiresAuth: true,
    }
  },
  {
    path: '/book_chinese',
    name: 'book_chinese',
    component: () => import('../components/book_chinese'),
    meta: {
      title: 'book_chinese',
      requiresAuth: true,
    }
  },
  {
    path: '/book_english',
    name: 'book_english',
    component: () => import('../components/book_english'),
    meta: {
      title: 'book_english',
      requiresAuth: true,
    }
  },
  {
    path: '/tingxie_english',
    name: 'tingxie_english',
    component: () => import('../components/tingxie_english'),
    meta: {
      title: 'tingxie_english',
      requiresAuth: true,
    }
  },
  {
    path: '/tingxie_chinese',
    name: 'tingxie_chinese',
    component: () => import('../components/tingxie_chinese'),
    meta: {
      title: 'tingxie_chinese',
      requiresAuth: true,
    }
  },
  {
    path: '/tingxie_chinese_start',
    name: 'tingxie_chinese_start',
    component: () => import('../components/tingxie_chinese_start'),
    meta: {
      title: 'tingxie_chinese_start',
      requiresAuth: true,
    }
  },
  {
    path: '/tingxie_english_start',
    name: 'tingxie_english_start',
    component: () => import('../components/tingxie_english_start'),
    meta: {
      title: 'tingxie_english_start',
      requiresAuth: true,
    }
  },
  {
    path: '/tingxie_chinese_result',
    name: 'tingxie_chinese_result',
    component: () => import('../components/tingxie_chinese_result'),
    meta: {
      title: 'tingxie_chinese_result',
      requiresAuth: true,
    }
  },
  {
    path: '/tingxie_english_result',
    name: 'tingxie_english_result',
    component: () => import('../components/tingxie_english_result'),
    meta: {
      title: 'tingxie_english_result',
      requiresAuth: true,
    }
  },
  {
    path: '/activation',
    name: 'activation',
    component: () => import('../components/activation'),
    meta: {
      title: 'activation',
      requiresAuth: true,
    }
  },
  {
    path: '/upload',
    name: 'upload',
    component: () => import('../components/upload'),
    meta: {
      title: 'upload',
      requiresAuth: true,
    }
  },
  {
    path: '/diandu',
    name: 'diandu',
    component: () => import('../components/diandu'),
    meta: {
      title: 'diandu',
      requiresAuth: true,
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/login'),
    meta: {
      title: 'login'
    }
  },
  {
    path: '/tools',
    name: 'tools',
    component: () => import('../components/tools'),
    meta: {
      title: 'tools'
    }
  },
  {
    path: '/audio',
    name: 'audio',
    component: () => import('../components/audio'),
    meta: {
      title: 'audio'
    }
  },
  {
    path: '/huiben',
    name: 'huiben',
    component: () => import('../components/huiben'),
    meta: {
      title: 'huiben'
    }
  },
  {
    path: '/huiben_detail',
    name: 'huiben_detail',
    component: () => import('../components/huiben_detail'),
    meta: {
      title: 'huiben_detail'
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  localStorage.setItem("previousPage", from.fullPath || "/");
  next();
});

export default router
